export default __webpack_public_path__ + "static/media/black_jack.62ff346a.webp";